import {ANALYTICS} from "@/store/analytics/helpers.js";

const AUDIO_STORAGE_KEY = "multiScreen.aircraftAudioEventsEnabled";
const VIDEO_STORAGE_KEY = "multiScreen.aircraftVideoEventsEnabled";

function readFilter(key) {
  try {
    return localStorage.getItem(key) !== "false";
  } catch {
    return true;
  }
}

function saveFilter(key, enabled) {
  try {
    localStorage.setItem(key, String(enabled));
  } catch (error) {
    devLog("[AircraftEventFilters] Failed to save filter", error);
  }
}

export function isAircraftEventEnabled(message, {aircraftAudioEventsEnabled, aircraftVideoEventsEnabled}) {
  if (message.analyticType === ANALYTICS.aircraft) {
    if (message.source_type === "audio") return aircraftAudioEventsEnabled;
    if (message.source_type === "video") return aircraftVideoEventsEnabled;
  }
  return true;
}

/** Общие настройки фильтрации aircraft для мультиэкрана, карты и окна выбора источника. */
export const aircraftEventFiltersMixin = {
  data() {
    return {
      aircraftAudioEventsEnabled: readFilter(AUDIO_STORAGE_KEY),
      aircraftVideoEventsEnabled: readFilter(VIDEO_STORAGE_KEY),
    };
  },
  watch: {
    aircraftAudioEventsEnabled(enabled) {
      saveFilter(AUDIO_STORAGE_KEY, enabled);
    },
    aircraftVideoEventsEnabled(enabled) {
      saveFilter(VIDEO_STORAGE_KEY, enabled);
    },
  },
  mounted() {
    window.addEventListener("storage", this.onAircraftEventFiltersStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onAircraftEventFiltersStorageChange);
  },
  methods: {
    onAircraftEventFiltersStorageChange(event) {
      if (event.storageArea !== localStorage || ![null, AUDIO_STORAGE_KEY, VIDEO_STORAGE_KEY].includes(event.key)) return;
      this.aircraftAudioEventsEnabled = readFilter(AUDIO_STORAGE_KEY);
      this.aircraftVideoEventsEnabled = readFilter(VIDEO_STORAGE_KEY);
    },
    isAircraftEventEnabled(message) {
      return isAircraftEventEnabled(message, this);
    },
  },
};
